import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgChatUrl from '@/assets/misc/img_chat.svg'
import WorkspaceIntercomIllustration from '@/components/SpotIllustration/WorkspaceIntercomIllustration'

export interface NotifyProsOfOpenJobDialogProps {
  showing: boolean
  onClose: () => unknown
  onNotify: () => unknown
  isNotifyPending: boolean
  submitButtonTestId?: string
}

export function NotifyProsOfOpenJobDialog({
  showing,
  onClose,
  onNotify,
  isNotifyPending,
  submitButtonTestId,
}: NotifyProsOfOpenJobDialogProps) {
  return (
    <ModalSheet
      onRequestClose={isNotifyPending ? undefined : onClose}
      showing={showing}
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContentIllustration
        src={imgChatUrl}
        illustration={byDesign(undefined, WorkspaceIntercomIllustration)}
        alt="Illustration of a hand holding a phone and reading a message"
      />

      <ModalSheetContent>
        <ModalSheetContentTitle>Notify Pros of open job</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Do you want to notify all available Pros?
        </ModalSheetContentDescription>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isNotifyPending}
            variant="default"
            onPress={onClose}
          />
          <Button
            label="Notify Pros"
            variant="primary"
            onPress={onNotify}
            isPending={isNotifyPending}
            testId={submitButtonTestId}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
